// extracted by mini-css-extract-plugin
export var certifications = "certifications-module--certifications--1vpYh";
export var certificationsInner = "certifications-module--certificationsInner--cVX-R";
export var item = "certifications-module--item--3b1XV";
export var png = "certifications-module--png--2rxfv";
export var gatsbyImage = "certifications-module--gatsbyImage--2owIk";